import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useFetchOrganizationMembershipsQuery } from '../api';
import { SearchFacet } from './search_facet';
const titleCss = "t1oflgw8";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
export const SearchInput = ({
  title,
  selectedIds,
  setSelectedIds,
  searchParams = {}
}) => {
  const [filterTerm, setFilterTerm] = useState('');
  const {
    data: collectionData,
    isLoading,
    isFetching
  } = useFetchOrganizationMembershipsQuery({
    filterTerm,
    ...searchParams
  });
  const collection = collectionData?.results || [];
  const {
    data: selectedData
  } = useFetchOrganizationMembershipsQuery({
    membershipIds: selectedIds
  }, {
    skip: selectedIds.length === 0
  });
  const selectedItems = selectedData?.results || [];
  const selected = selectedIds.map(userId => collection.find(({
    id
  }) => id === userId) || selectedItems.find(({
    id
  }) => id === userId)).filter(Boolean);
  const onSelect = items => {
    setSelectedIds(items.map(({
      id
    }) => id));
  };
  return <SearchFacet title={<Title>{title}</Title>} collection={collection} selected={selected} disabled={isLoading} isLoading={isFetching} onSelect={onSelect} setSearchTerm={setFilterTerm} />;
};

require("./search_input.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_input.js");